const LokultNewsPosts = ({ post }) => {
  const createdDate = new Date(post.date_created).toLocaleDateString("sv-SE", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <article className="group m-auto w-full max-w-3xl overflow-hidden rounded-2xl border border-base-content/20 bg-base-200 shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl">
      <div className="h-1.5 w-full bg-gradient-to-r from-primary/60 via-accent to-secondary/70" />
      <div className="p-5 sm:p-7">
        <div className="mb-5 flex items-start justify-between gap-4">
          <a
            href="/lokult-news"
            className="text-xl font-bold leading-tight text-white transition-colors hover:text-primary sm:text-2xl"
          >
            {post.title}
          </a>
          <a
            href="/lokult-news"
            className="badge badge-accent badge-lg shrink-0"
          >
            Lokult
          </a>
        </div>

        <div
          className="prose prose-invert max-w-none prose-headings:mb-2 prose-p:my-3 prose-a:text-primary"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />

        <div className="mt-6 flex items-center justify-between border-t border-base-content/10 pt-4 text-sm text-base-content/70">
          <p className="uppercase tracking-wide">Uppdatering</p>
          <p>Publicerad {createdDate}</p>
        </div>
      </div>
    </article>
  );
};

export default LokultNewsPosts;
